import { scrollToNavigableItem } from '../schemableFormNavigation/navigationHelpers';
import { NavigationService } from '../schemableFormNavigation/schemableFormNavigation';
import { SuggestionNavigableItem } from './types';

export class SuggestionNavigationService extends NavigationService<SuggestionNavigableItem> {
  constructor() {
    super();
  }

  setItems = (items: Array<SuggestionNavigableItem>): void => {
    this.store.getState().setItems(items);
  };

  focusOnCurrentItem = async (): Promise<void> => {
    const target = this.getCurrentItem() ?? this.store.getState().items[0];

    if (target) {
      return scrollToNavigableItem(target, this.scrollToVirtualizedRow, this.containerRef);
    }
  };
}
